import { Menu } from '@headlessui/react'
import { Link } from 'react-router-dom'


type PropTypes = {
  to: string
  children: React.ReactNode
}

const PopoverMenuLink = ({ to, children }: PropTypes) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <Link
          className={`${
            active ? 'bg-gray-700' : ''
          } group flex w-full items-center px-2 py-2 text-sm text-white rounded-[5px]`}
          to={to}
        >
          {children}
        </Link>
      )}
    </Menu.Item>
  )
}

export default PopoverMenuLink
